import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { Box, Select, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'
import { CHAT_BOTS } from '../../constants/chat_bot'
import Profile from '../../classes/profile'

class ChatBotHeaderComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    profile: Profile.PropTypes,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    selectedView: PropTypes.string,
    setSelectedView: PropTypes.func,
    fetchThreadId: PropTypes.func,
    selectedViewAssistantId: PropTypes.string
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedView != this.props.selectedView) {
      const user = {}
      if (this.props.profile && !this.props.shortcut) {
        user.email = this.props.profile.email
        user.groups = this.props.profile.groups
      }
      this.props.fetchThreadId(this.props.selectedViewAssistantId, JSON.stringify(user))
    }
  }

  handleViewChange = (event) => {
    this.props.setSelectedView(event.target.value)
  }

  render () {
    const { homepage } = this.props
    let provisionedChatBots = homepage && homepage.details && homepage.details.chat_bots && homepage.details.chat_bots.length > 0 ? homepage.details.chat_bots : []
    provisionedChatBots = provisionedChatBots.sort((a, b) => {
      // Sort 'true' values (1) before 'false' values (0)
      return b.is_default - a.is_default
    }).map(e => e.name)
    let bots = CHAT_BOTS.filter(bot =>
      provisionedChatBots.includes(bot.botValue)
    )
    bots = bots.sort((a, b) => {
      return provisionedChatBots.indexOf(a.botValue) - provisionedChatBots.indexOf(b.botValue)
    })
    return (
      <Row className="header audience attention">
        <Col>
          <ul className="hFirstRow balanceVerticalAlign">
            <li className="imgHolder">
              <div id='attention_header_img'>
                <img src="/static/images/acquisition-main.png" alt="logo" className="imgThumb" onError={(e)=>{e.target.style = 'display: none;';}} />
              </div>
            </li>
            { this.props.shortcut &&
              <li>
                <h2 className="title">{CHAT_BOTS.filter(e => e.botValue === this.props.shortcut.target)[0].botName}</h2>
              </li>
            }
            { (!this.props.shortcut && provisionedChatBots.length == 1) &&
              <li>
                <h2 className="title">{bots[0].botName}</h2>
              </li>
            }
            { (!this.props.shortcut && provisionedChatBots.length > 1) &&
              <li>
                <Select
                  labelId="select-filled-label"
                  id="select-filled"
                  className='streamSelect'
                  value={this.props.selectedView}
                  onChange={(e) => this.handleViewChange(e)}
                >
                  {
                    bots.map(e => {
                      return (
                        <MenuItem key={e.botValue} value={e.botValue} className='optionBox'>
                          <Box className="d-flex flex-column pt-1">
                            <span className="optionLabel">{e.botName}</span>
                          </Box>
                        </MenuItem>
                      )
                    })
                  }
                </Select>
              </li>
            }
          </ul>
        </Col>
      </Row>
    )
  }
}

export default withStyles(styles)(ChatBotHeaderComponent)
